export const OOPS: string = "Oops!";
export const NOT_FOUND_404: string = "404 Not Found";
export const PAGE_NOT_FOUND_MESSAGE: string =
  "Sorry, an error has occured, Requested page not found!";
export const GO_TO_HOME: string = "Go To Home";
